import duocolorData from '@bettermode/icons/picker/duocolor/data.json' with { type: 'json' }
import lineData from '@bettermode/icons/picker/line/data.json' with { type: 'json' }
import solidData from '@bettermode/icons/picker/solid/data.json' with { type: 'json' }

import { PickerIconData, PickerIconPack } from '../types.js'

export const getIcons = (pack: PickerIconPack) => {
  switch (pack) {
    case 'line':
      return lineData as PickerIconData[]
    case 'solid':
      return solidData as PickerIconData[]
    case 'duocolor':
      return duocolorData as PickerIconData[]
    default: {
      const exhaustiveCheck: never = pack
      return exhaustiveCheck
    }
  }
}
